import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ArticleTaskModel } from 'src/app/models/others/article-task.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleTaskTableModel } from 'src/app/models/tables/others/article-task-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ArticleTaskService {

  constructor(private _httpClient: HttpClient) { }

  closeTaskAsync(articleTaskId: number): Observable<ArticleTaskModel> {
    return this._httpClient.post<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.CloseTaskAsync}/${articleTaskId}`,
      null);
  }

  createAsync(ArticleTaskModel: ArticleTaskModel): Observable<ArticleTaskModel> {
    return this._httpClient.post<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.CreateAsync}`,
      ArticleTaskModel);
  }

  deleteAsync(articleTaskId: number): Observable<ArticleTaskModel> {
    return this._httpClient.delete<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.DeleteAsync}/${articleTaskId}`);
  }

  executeTaskAsync(articleTaskId: number): Observable<ArticleTaskModel> {
    return this._httpClient.post<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.ExecuteTaskAsync}/${articleTaskId}`,
      null);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllArticles(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetAllArticlesAsync}`,
      filters, { params: params }
    );
  }

  getAllArticlesForSelect(): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetAllArticlesForSelectAsync}`);
  }

  getAllArticleTasksWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetAllArticleTasksWithPaginationAsync}`,
      filters, { params: params });
  }

  getArticleTaskPending(): Observable<ArticleTaskTableModel[]> {
    return this._httpClient.get<ArticleTaskTableModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetArticleTaskPendingAsync}`);
  }

  getByIdAsync(articleTaskId: number): Observable<ArticleTaskModel> {
    return this._httpClient.get<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetByIdAsync}/${articleTaskId}`);
  }

  getColumnsForArticles(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetColumnsForArticlesAsync}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstArticleTaskByKeysAsync(branchId: number): Observable<ArticleTaskModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetFirstArticleTaskByKeys}`,
      { params: params }
    );
  }

  getLastArticleTaskByKeysAsync(branchId: number): Observable<ArticleTaskModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetLastArticleTaskByKeys}`,
      { params: params }
    );
  }

  getArticleTaskByKeysAsync(branchId: number, consecutive: number): Observable<ArticleTaskModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetArticleTaskByKeys}`,
      { params: params }
    );
  }

  getNextArticleTaskByKeysAsync(branchId: number, consecutive: number | null): Observable<ArticleTaskModel> {
    let params = new HttpParams().set('branchId', branchId);
    if (consecutive !== null)
      params = params.set('consecutive', consecutive.toString());
    return this._httpClient.get<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetNextArticleTaskByKeys}`,
      { params: params }
    );
  }

  getPreviusArticleTaskByKeysAsync(branchId: number, consecutive: number | null): Observable<ArticleTaskModel> {
    let params = new HttpParams().set('branchId', branchId);
    if (consecutive !== null)
      params = params.set('consecutive', consecutive.toString());
    return this._httpClient.get<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetPreviusArticleTaskByKeys}`,
      { params: params }
    );
  }

  getTotalArticleTaskPendingAsync(): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.GetTotalArticleTaskPendingAsync}`);
  }

  updateAsync(articleTaskContract: ArticleTaskModel): Observable<ArticleTaskModel> {
    return this._httpClient.put<ArticleTaskModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.articleTask.UpdateAsync}`,
      articleTaskContract);
  }

}
